export default () => [
  {
    label: 'Search for a city',
    trackingFieldName: 'currentcity_change',
    viewType: 'custom',
    componentName: 'cityInput',
    formatType: 'none',
  },
];
